import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/refreshTokens.ts
import { Exception } from "@wbk/logger";
var refreshTokens = (refresh_token) => __async(null, null, function* () {
  var _a, _b, _c, _d;
  try {
    const data = yield fetchClient({
      url: "/refresh_token",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify({
          refresh_token,
          app_source: (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.appSource
        })
      }
    });
    return data;
  } catch (error) {
    throw new Exception({ error, name: "refreshTokensException" });
  }
});

export {
  refreshTokens
};
//# sourceMappingURL=chunk-5DBT6SVI.mjs.map